import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  IconButton,
  Avatar,
  Button
} from "@mui/material";
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';

export default function Header({ darkMode, setDarkMode }) {
  // Lấy user từ localStorage (nếu đã lưu ở login)
  let user = null;
  try {
    const u = localStorage.getItem("user");
    user = u ? JSON.parse(u) : null;
  } catch { user = null; }

  // Xử lý logout
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    window.location.href = "/";
  };

  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{ bgcolor: "transparent", boxShadow: "none" }}
    >
      <Toolbar sx={{ justifyContent: "space-between", px: 2 }}>
        <Typography variant="h6" fontWeight={900} color="primary">
          Dashboard Admin
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {/* Hiển thị tên user + avatar nếu có */}
          {user && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Avatar src={user.avatar || ""} alt={user.name || user.username || ""} sx={{ width: 36, height: 36 }} />
              <Typography sx={{ fontWeight: 700, color: "primary.main" }}>
                {user.name || user.username}
              </Typography>
            </Box>
          )}
          {/* Nút chuyển dark mode */}
          <IconButton onClick={() => setDarkMode(!darkMode)} color="inherit">
            {darkMode ? <Brightness7Icon /> : <Brightness4Icon />}
          </IconButton>
          {/* Nút logout */}
          <Button
            variant="outlined"
            color="error"
            onClick={handleLogout}
            sx={{
              borderRadius: 999,
              textTransform: "none",
              fontWeight: 700,
              ml: 1
            }}
          >
            Đăng xuất
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
